<template>
  <div class="analyse">
    <div style="width:1002px;margin: 0 auto">
      <common-header :course-name="courseName" v-if="!isPrint"/>
    </div>
    <div class="analyse_main">
      <div class="leftCon" v-if="!isPrint">
        <a href="javascript:void(0)" class="leftbtn" @click="backIndex">返回系统管理目录</a>
        <div class="fixedCon" :style="{position: isFixed}">
          <div class="main-title"><h2>错题练习</h2></div>
          <div class="quesTypeList">
            <div :class="item.isShow ? 'flnr' : 'flnr flnr-hidden'"
                 v-for="(item, index) in quesTypeShowMap"
                 :key="index">
              <template v-if="item.lists.length && item.quesTypeID !== 4">
                <div class="sub-title" @click="slide(index)">
                  <h3>{{ item.viewTypeName }}(<span>{{ item.lists && item.lists.length }}</span>题)</h3>
                </div>
                <div :style="tabShowHeight(item)" class="jx_lcen">
                  <template v-for="(ans, index2) in item.lists">
                    <template v-if="ans.smallContent === undefined">
                      <ul style="padding-top: 2px; padding-bottom: 2px;" :key="index2 + 'a'">
                        <a href="javascript:void(0)" @click="goIntoView('ref' + ans.questionID)" >
                          <li class="answered" v-if="isAnswer(ans.answerState)"><span>{{ index2 + 1 }}</span>已练习</li>
                          <li class="unAnswered" v-else><span>{{ index2 + 1 }}</span>未练习</li>
                        </a>
                      </ul>
                    </template>
                    <template v-if="ans.smallContent !== undefined">
                      <ul v-for="(smallQues, index3) in ans.smallContent" :key="index3 + 'b'"
                          style="padding-top: 2px; padding-bottom: 2px;">
                        <a href="javascript:void(0)" @click="goIntoView('ref' + smallQues.questionID)" >
                          <li class="answered" v-if="isAnswer(smallQues.answerState)">
                            <span>{{ index2 * ans.smallContent.length + index3 + 1 }}</span>已练习
                          </li>
                          <li class="unAnswered" v-else>
                            <span>{{ index2 * ans.smallContent.length + index3 + 1 }}</span>未练习
                          </li>
                        </a>
                      </ul>
                    </template>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rightCon" :style="isPrint ? `width: 980px;` : `width: 767px;`">
        <div v-if="!isPrint" class="right-top">
          <div class="top-left">
            当前位置：机考模拟系统 &gt; 答案解析 &gt; {{ commonInfo.examName }}
          </div>
          <div class="top-right">
            <a @click="changeFontSize(12)" href="javascript:void(0)">小</a>
            <a @click="changeFontSize(13)" href="javascript:void(0)" class="sizeMid">中</a>
            <a @click="changeFontSize(15)" href="javascript:void(0)">大</a>
            <a @click="backIndex" href="javascript:void(0)" class="btn back-btn">返回首页</a>
            <a @click="handlePrint" href="javascript:void(0)" class="btn">打印</a>
          </div>
        </div>
        <div class="top-title"><p>{{ commonInfo.examName }} ——错题练习</p></div>
        <div :style="'font-size:' + mainSize" class="mainright">
          <div v-for="(elem, index1) in quesTypeShowMap" :key="index1 + 'd'">
            <template v-if="elem.lists.length && elem.quesTypeID !== 4">
              <div class="queType-title">{{ elem.showSerialNum }}、{{ elem.viewTypeName }}</div>
              <div v-for="(ans, index2) in elem.lists" :key="index2 + 'e'">
                <!--客观题-->
                <template v-if="ans.smallContent === undefined">
                  <div v-if="ans.quesTypeID === 1">
                    <a class="que-title" :id="ans.questionID" :ref="'ref' + ans.questionID" href="javascript:void (0)">{{ (index2 + 1) + '、' +
                      ans.content }}</a>
                    <div v-for="(option, index) in ans.optionList" :key="index" class="choice">
                      <input type="radio"
                             :name="ans.questionID"
                             :value="option.quesValue"
                             v-model="ans.answerState"
                             @click="radioToggleFn(ans, option.quesValue)"
                             :ref="ans.questionID">
                      <strong class="ml10">{{ option.quesValue }}.&nbsp;</strong>
                      <span v-html="option.quesOption"/>
                    </div>
                  </div>
                  <div v-if="ans.quesTypeID === 2">
                    <a class="que-title" :id="ans.questionID"  :ref="'ref' + ans.questionID" href="javascript:void (0)">{{ (index2 + 1) + '、' +
                      ans.content }}</a>
                    <div v-for="(option, index) in ans.optionList" :key="index" class="choice">
                      <input type="checkbox"
                             :value="option.quesValue"
                             :id="option.quesValue"
                             v-model="option.checked"
                             @click="radioToggleFn(ans, option.quesValue)"
                             :ref="ans.questionID">
                      <strong class="ml10">{{ option.quesValue }}.&nbsp;</strong>
                      <span v-html="option.quesOption"/>
                    </div>
                  </div>
                  <div v-if="ans.quesTypeID === 3">
                    <a class="que-title" :id="ans.questionID"  :ref="'ref' + ans.questionID" href="javascript:void (0)">{{ (index2 + 1) + '、' +
                      ans.content }}</a>
                    <div v-for="(option, index) in ans.optionList" :key="index" class="choice">
                      <input type="radio"
                             :name="ans.questionID"
                             :value="option.quesValue"
                             v-model="ans.answerState"
                             @click="radioToggleFn(ans, option.quesValue)"
                             :ref="ans.questionID">
                      <span class="ml10" v-html="option.quesOption"/>
                    </div>
                  </div>
                  <div class="right-btns">
                    <a href="javascript:void(0)" class="fr" @click="quiz(ans.questionID)">【答疑编号{{ ans.questionID
                      }}，点击提问】</a>
                    <a href="javascript:void(0)" class="fr collect-btn"
                       @click="collectQues(ans.questionID, ans.chapterID)">【加入题库收藏夹】</a>
                    <a href="javascript:void(0)" class="fr delete-btn" @click="deleteQues(ans.questionID)">【删除】</a>
                  </div>
                  <div class="showOrHideAnswer" @click="toggleAnalyse(ans)"
                       v-text="ans.showAnswer ? '【隐藏答案】' : '【显示答案】'"></div>
                  <div class="answer-box" v-if="ans.showAnswer">
                    <strong class="answer-right">【正确答案】</strong>
                    <span v-html="ans.answer"/><br/>
                    <strong class="answer-ananlysis">【答案解析】</strong>
                    <span v-html="ans.analysis"/><br/>
                    <strong class="answer-user">【您的答案】</strong>
                    <span v-html="ans.userAnswer"/>
                  </div>
                </template>
                <!--主观题-->
                <template v-else>
                  <a href="javascript:void(0)" :id="ans.questionID"
                     v-html="'<' + (index2 + 1) + '>、' + ans.content"></a>
                  <template v-for="(smallQues, index3) in ans.smallContent">
                    <template v-if="smallQues.quesTypeID === 1">
                      <div class="jx_tmtit" :key="index3 + 'g'">
                        <a href="javascript:void(0)" :id="smallQues.questionID" :ref="'ref' + smallQues.questionID"
                          v-html="(index2 * ans.smallContent.length + index3 + 1) + '、' + smallQues.content"/>
                      </div>
                      <div v-for="(option, index4) in smallQues.optionList" :key="index4 + 'o'">
                        <input type="radio"
                              :name="smallQues.questionID"
                              :value="option.quesValue"
                              v-model="smallQues.answerState"
                              @click="radioToggleFn(smallQues, option.quesValue)"
                              :ref="smallQues.questionID">
                        <strong class="ml10">{{ option.quesValue }}.&nbsp;</strong>
                        <span v-html="option.quesOption"/>
                      </div>
                    </template>
                    <template v-else-if="smallQues.quesTypeID === 2">
                      <div class="jx_tmtit" :key="index3 + 'g'">
                        <a href="javascript:void(0)" :id="smallQues.questionID"  :ref="'ref' + smallQues.questionID"
                          v-html="(index2 * ans.smallContent.length + index3 + 1) + '、' + smallQues.content"/>
                      </div>
                      <div v-for="(option, index4) in smallQues.optionList" :key="index4 + 'm'">
                        <input type="checkbox"
                              :value="option.quesValue"
                              :id="option.quesValue"
                              v-model="option.checked"
                              @click="radioToggleFn(smallQues, option.quesValue)"
                              :ref="smallQues.questionID">
                        <strong class="ml10">{{ option.quesValue }}.&nbsp;</strong>
                        <span v-html="option.quesOption"/>
                      </div>
                    </template>
                    <template v-else-if="smallQues.quesTypeID === 3">
                      <div class="jx_tmtit" :key="index3 + 'g'">
                        <a href="javascript:void(0)" :id="smallQues.questionID" :ref="'ref' + smallQues.questionID"
                          v-html="(index2 * ans.smallContent.length + index3 + 1) + '、' + smallQues.content"/>
                      </div>
                      <div v-for="(option, index4) in smallQues.optionList" :key="index4 + 'n'">
                        <input type="radio"
                              :name="smallQues.questionID"
                              :value="option.quesValue"
                              v-model="smallQues.answerState"
                              @click="radioToggleFn(smallQues, option.quesValue)"
                              :ref="smallQues.questionID">
                        <strong class="ml10">{{ option.quesValue }}.&nbsp;</strong>
                        <span v-html="option.quesOption"/>
                      </div>
                    </template>
                    <!-- <div v-for="(option, index4) in smallQues.optionList" :key="index4 + 'h'">
                      <input type="checkbox"
                             :name="smallQues.questionID"
                             :value="option.quesValue"
                             :id="option.quesValue"
                             v-model="option.checked"
                             @click="radioToggleFn(smallQues, option.quesValue)"
                             :ref="smallQues.questionID">
                      <strong class="ml10">{{ option.quesValue }}.&nbsp;</strong>
                      <span v-html="option.quesOption"/>
                    </div> -->
                    <div class="right-btns" :key="index3 + 'i'">
                      <a href="javascript:void(0)" class="fr" @click=" quiz(smallQues.questionID)">【答疑编号{{
                        smallQues.questionID }}，点击提问】</a>
                      <a href="javascript:void(0)" class="fr collect-btn"
                         @click="collectQues(smallQues.questionID, smallQues.chapterID, ans.questionID)">【加入题库收藏夹】</a>
                      <a href="javascript:void(0)" class="fr delete-btn"
                         @click="deleteQues(ans.questionID, ans.questionID)">【删除】</a>
                    </div>
                    <div :key="index3 + 'hi'">
                      <div class="showOrHideAnswer" @click="toggleAnalyse(smallQues)"
                           v-text="smallQues.showAnswer ? '【隐藏答案】' : '【显示答案】'"></div>
                      <div class="answer-box" v-if="smallQues.showAnswer">
                        <strong class="answer-right">【正确答案】</strong>
                        <span v-html="smallQues.answer"/><br/>
                        <strong class="answer-ananlysis">【答案解析】</strong>
                        <span v-html="smallQues.analysis"/><br/>
                        <strong class="answer-user">【您的答案】</strong>
                        <span v-html="smallQues.userAnswer"/>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="floatTips"><a href="javascript:scrollTo(0,0);">返回顶部</a></div>

    <common-footer/>
  </div>
</template>

<script>
  import { CommonHeader, CommonFooter } from '@components/common'
  import { getCookie, LoadingOptions } from "@/utils"
  import { getQuesAnaly, updatePaperRecord, addFavoriteQues } from '@/api'

  export default {
    name: 'mistakeRedo',
    components: {
      CommonHeader,
      CommonFooter
    },
    data() {
      return {
        loadingInstance: null,
        mainSize: '13px',
        isPrint: false,
        //四大对象
        quesTypeShowMap: {},
        quesShowList: [],
        userAnsMap: {},
        commonInfo: {},
        // 获取路由参数
        flag: '',
        courseID: '',
        majorID: '',
        siteCourseID: '',
        eduSubjectID: '',
        courseName: '',
        majorName: '',
        isWrongQues: false, // 是否是错题解析状态
        wrongQuesList: [],
        isFixed: 'relative',
        mistake: ''
      }
    },
    async mounted() {
      const { flag } = this.$route.params
      this.flag = flag === 'paidExam' ? '' : flag
      this.courseID = this.$route.query.courseID
      this.siteCourseID = this.$route.query.siteCourseID

      this.courseName = getCookie('courseName') || ''
      this.mistake = this.$route.query.mistake ? this.$route.query.mistake.toString() : ''
      document.title = this.courseName + '机考模拟系统'
      /* window.addEventListener('scroll', () => {
         let scrollTop = 0
         if (document.documentElement) {
           scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
         }
         this.isFixed = scrollTop > 180 ? 'fixed' : 'relative'
       })*/
      this.loadingInstance = this.$loading(LoadingOptions)
      let result = await getQuesAnaly({
        flag: this.flag,
        bizID: Number(this.$route.query.bizID)
      })
      this.$nextTick(() => {
        this.loadingInstance.close()
      })
      this.quesShowList = result.quesShowList
      this.userAnsMap = result.userAnsMap
      this.quesTypeShowMap = result.quesTypeShowMap
      this.commonInfo = result.commonInfo

      //  遍历生成错题列表
      outermost: for (let i = 0; i < this.quesShowList.length; i++) {
        let item = this.quesShowList[i]
        let itemChilds = item.childQuesIDs
        if (itemChilds && itemChilds !== 'mixed') {
          let itemChildsArr = itemChilds.split(',')
          for (let smallID = 0; smallID < itemChildsArr.length; smallID++) {
            let index = itemChildsArr[smallID]
            if ((this.userAnsMap[index].answer !== this.userAnsMap[index].userAnswer) && (this.userAnsMap[index].userAnswer) && this.userAnsMap[index].isDel !== 1) {
              this.wrongQuesList.push(item)
              itemChildsArr.forEach(elementID => {
                this.$set(this.userAnsMap[elementID], 'answerState', '')
                this.userAnsMap[elementID].showAnswer = false
                this.userAnsMap[elementID].optionList && this.userAnsMap[elementID].optionList.forEach(option => {
                  option.checked = false
                })
              })
              continue outermost
            }
          }
        }
        if ((this.userAnsMap[item.questionID].answer !== this.userAnsMap[item.questionID].userAnswer) && (this.userAnsMap[item.questionID].userAnswer) && this.userAnsMap[item.questionID].isDel !== 1) {
          this.wrongQuesList.push(item)
          this.$set(this.userAnsMap[item.questionID], 'answerState', '')
          this.userAnsMap[item.questionID].showAnswer = false
          this.userAnsMap[item.questionID].optionList.forEach(item => {
            item.checked = false
          })
        }
      }
      this.isWrongQues = this.mistake === '1' ? true : false
      this.questionsMap()
    },
    methods: {
      //  判断小题是否有答案
      isAnswer(value) {
        if (Array.isArray(value)) {
          return value.length
        } else if (value === null || value === '') {
          return false
        } else {
          return true
        }
      },
      //切换字体大小
      changeFontSize(size) {
        this.mainSize = `${size}px`
      },
      //计算每一个题型高度
      tabShowHeight(item) {
        if (item.isShow) {
          let height = 0
          item.lists.forEach((list) => {
            if (list.smallContent) {
              height = height + (list.smallContent.length * 28)
            } else {
              height = height + 28
            }
          })
          return `height: ${height}px;`
        } else {
          return 'height: 0px;'
        }
      },
      //点击打印
      handlePrint() {
        this.isPrint = true
        setTimeout(() => {
          window.print()
          this.isPrint = false
        }, 0)
      },
      //点击返回首页
      backIndex() {
        this.$router.push({
          name: 'MockExam',
          query: {
            siteCourseID: this.siteCourseID,
            courseID: this.courseID
          }
        })
      },
      //题型目录展开收起
      slide(idx) {
        this.quesTypeShowMap[idx].isShow = !this.quesTypeShowMap[idx].isShow
        this.$forceUpdate()
      },
      //加入题库收藏夹
      async collectQues(questionID, chapterID, parentID) {
        const questionIDParam = parentID ? parentID : questionID
        let collectQuesParams = {
          flag: this.flag,
          courseID: parseInt(this.courseID),
          userID: parseInt(getCookie('cdeluid')),
          questionID: questionIDParam,
          chapterID
        }
        await addFavoriteQues(collectQuesParams).then(() => {
          this.$message({
            showClose: true,
            message: '题目收藏成功！',
            type: 'success'
          })
        })
      },
      //点击提问
      quiz(questionID) {
        window.open('//member.chinaacc.com/faq/query.shtm?Forum_ID=' + this.siteCourseID + '&QNo=' + questionID)
      },
      //点击删除
      async deleteQues(questionID, parentID) {
        this.$confirm(parentID ? '删除不定项选择题的小题将同时删除相同题目下的其他小题，是否继续？' : '此操作将删除这道错题, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          const questionIDParam = parentID ? parentID : questionID
          //判断是否是大题套小题
          if (parentID) {
            for (let item in this.wrongQuesList) {
              if (this.wrongQuesList[item].questionID === questionIDParam) {
                let itemChildsArr = this.wrongQuesList[item].childQuesIDs.split(',')
                itemChildsArr.forEach(elementID => {
                  this.userAnsMap[elementID].isDel = 1
                  // this.userAnsMap[elementID].userAnswer = this.userAnsMap[elementID].mistakeAnswer
                })
              }
            }
          } else {
            this.userAnsMap[questionIDParam].isDel = 1
            // this.userAnsMap[questionIDParam].userAnswer = this.userAnsMap[questionIDParam].mistakeAnswer
          }
          this.commonInfo.bizID = this.$route.query.bizID
          let params = {
            userAnsMap: this.userAnsMap,
            quesShowList: this.quesShowList,
            quesTypeShowMap: this.quesTypeShowMap,
            commonInfo: this.commonInfo,
            bizID: this.$route.query.bizID
          }
          //后台新增需求commonInfo中增加参数errorDelFlag=1
          params.commonInfo['errorDelFlag']=1
          await updatePaperRecord(params).then(() => {
            let index_wrong = 0
            for (let item in this.wrongQuesList) {
              if (this.wrongQuesList[item].questionID === questionIDParam) {
                this.wrongQuesList.splice(index_wrong, 1)
                this.questionsMap()
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                  customClass: 'user-defined-style',
                  duration: 2000,
                  showClose: true
                })
                this.$forceUpdate()
                return
              }
              index_wrong++
            }
          })
        })
      },
      //遍历题型
      questionsMap() {
        let questionsArr = this.isWrongQues ? this.wrongQuesList : this.quesShowList // 判断循环数组
        for (let quesType in this.quesTypeShowMap) {
          this.quesTypeShowMap[quesType].lists = [] // 题目list
          this.quesTypeShowMap[quesType].isShow = true // 菜单显示状态
          this.quesTypeShowMap[quesType].quesTypeID = 0
          // 遍历questionsArr
          for (let i = 0; i < questionsArr.length; i++) {
            let item = questionsArr[i]
            let itemChilds = item.childQuesIDs
            if (this.quesTypeShowMap[quesType].relOrder === item.relOrder) {
              if (itemChilds && itemChilds !== 'mixed') { // 判断 是否属于大题套小题
                let itemChildsArr = itemChilds.split(',')
                let smallContent = []
                for (let smallID = 0; smallID < itemChildsArr.length; smallID++) {
                  smallContent.push(this.userAnsMap[itemChildsArr[smallID]])
                  this.quesTypeShowMap[quesType].quesTypeID = this.userAnsMap[itemChildsArr[smallID]].quesTypeID
                }
                this.userAnsMap[item.questionID].smallContent = smallContent
                this.quesTypeShowMap[quesType].lists.push(this.userAnsMap[item.questionID])
              } else {
                this.quesTypeShowMap[quesType].lists.push(this.userAnsMap[questionsArr[i].questionID])
                this.quesTypeShowMap[quesType].quesTypeID = this.userAnsMap[questionsArr[i].questionID].quesTypeID
              }
            }

          }
        }
      },
      //点击做题input
      radioToggleFn(question) {
        this.$nextTick(() => {
          if (question.answerState === question.tempAnswer) {
            question.answerState = null
            question.isAnswer = 0
            question.tempAnswer = ""
          } else {
            question.tempAnswer = question.answerState
          }
          if (question.quesTypeID === 2) {
            for (let item of question.optionList) {
              if (item.checked) {
                question.answerState = 'true'
                return
              } else {
                question.answerState = ''
              }
            }
          }
          question.isAnswer = question.answerState ? 1 : 0
        })
      },
      //答案显示隐藏
      toggleAnalyse(question) {
        question.showAnswer = !question.showAnswer
        this.$forceUpdate()
      },
      // 锚点跳转
      goIntoView(selector) {
         this.$refs[selector][0].scrollIntoView({
          behavior: "auto",  // 平滑过渡
          block:    "start"  // 上边框与视窗顶部平齐。默认值
      });
      }
    }

  }
</script>

<style lang="scss" scoped>
  $bgUrl: '~@/assets/images';
  .analyse {
    p, table, img, ul, li, h2, h3, h4, dl, dt, dd, input {
      padding: 0;
      margin: 0;
    }

    .fl {
      float: left
    }

    .fr {
      float: right
    }

    .ml10 {
      margin-left: 10px;
    }

    .analyse_main {
      width: 1002px;
      overflow: auto;
      margin: 0px auto;
      background-color: rgb(218, 239, 255);

      .leftCon {
        position: relative;
        width: 218px;
        overflow: hidden;
        padding-left: 3px;
        float: left;
        display: inline;
        background-color: rgb(218, 239, 255);

        .leftbtn {
          display: inline-block;
          width: 100%;
          height: 24px;
          text-align: center;
          line-height: 24px;
          font-size: 12px;
          margin-top: 5px;
          margin-bottom: 5px;
          background: url($bgUrl + "/simexam/leftbtn.jpg") no-repeat;
        }

        .fixedCon {
          top: 0;
          border: 1px solid #9cd9ff;
          border-top: none;
          background-color: #fff;

          .main-title {
            height: 28px;
            background: url($bgUrl + "/simexam/jx_titlebg1.jpg") repeat-x;

            h2 {
              color: #fff;
              line-height: 28px;
              padding-left: 85px;
              font-size: 14px;
              font-weight: 600;
              background: url($bgUrl + "/simexam/jx_xb1.jpg") 60px 6px no-repeat;
            }
          }
        }

        .quesTypeList {
          width: 214px;
          height: 500px;
          overflow-x: hidden;
          overflow-y: auto;

          .sub-title {
            width: 183px;
            height: 30px;
            margin: 7px auto 0;
            background: url($bgUrl + "/simexam/jx_btnn.jpg") no-repeat;
            cursor: pointer;

            h3 {
              height: 30px;
              color: #04446b;
              line-height: 30px;
              padding-left: 30px;
              font-size: 14px;
              font-weight: 600;
            }
          }

          .flnr {
            .sub-title {
              h3 {
                background: url($bgUrl + "/simexam/jx_nxb2.jpg") 10px 8px no-repeat;
              }
            }

            .jx_lcen {
              overflow: hidden;
              transition: height 0.5s;
            }
          }

          .flnr-hidden {
            .sub-title h3 {
              background: url($bgUrl + "/simexam/jx_nxb.jpg") 10px 8px no-repeat;
            }
          }

          ul {
            overflow: auto;
            padding: 10px;
            margin-left: 20px;

            li {
              height: 24px;
              line-height: 24px;
              padding-left: 25px;
              font-size: 14px;
              background: url($bgUrl + "/simexam/jx_xb3.jpg") 10px 6px no-repeat;

              span {
                color: #1878d6;
                margin-right: 20px;
              }
            }

            .answered {
              color: #04446b;
            }

            .unAnswered {
              color: #f5431f;

              span {
                color: #1878d6;
              }
            }
          }
        }
      }

      .rightCon {
        width: 767px;
        float: right;
        background-color: rgb(218, 239, 255);

        .right-top {
          height: 31px;
          line-height: 31px;
          padding-left: 10px;
          font-size: 12px;

          .top-left {
            float: left;
            color: #808080;
          }

          .top-right {
            float: right;
            color: #333333;

            .sizeMid {
              margin: 0 10px;
            }

            .btn {
              padding: 2px 10px;
              border: 1px solid #fdd096;
              background: #FAFDE8;
              margin-right: 10px;
            }

            .back-btn {
              margin-left: 15px;
            }
          }
        }

        .top-title {
          width: 762px;
          height: 33px;
          color: #034568;
          line-height: 33px;
          overflow: hidden;
          font-size: 12px;
          background: url($bgUrl + "/simexam/ct_titbg.jpg") repeat-x;

          p {
            width: 90%;
            text-align: center;
            color: #04446b;
            line-height: 30px;
            font-size: 14px;
            font-weight: 600;
          }
        }

        .mainright {
          width: 767px;
          padding: 10px 20px;
          font-size: 12px;
          border: 1px solid #a2dbff;
          background-color: #fff;

          .queType-title {
            line-height: 30px;
            font-size: 16px;
            font-weight: 600;
          }

          .que-title {
            margin: 5px 0;
            line-height: 22px;
          }

          .choice {
            line-height: 22px;

            input {
              position: relative;
              top: 2px;
            }

            span {
              max-width: 650px;
              white-space: normal;
            }
          }

          .showOrHideAnswer {
            color: #057913;
            cursor: pointer;
            line-height: 30px;
          }

          .answer-box {
            padding: 3px;
            line-height: 26px;
            border: 1px dotted rgb(255, 102, 0);

            .answer-ananlysis {
              color: #057913;
            }

            .answer-right {
              color: #ff0000;
            }

            .answer-user {
              color: #0000ff;
            }
          }

          .right-btns {
            height: 30px;
            overflow: hidden;
            color: #00f;

            .collect-btn {
              color: #9900CC;
            }

            .delete-btn {
              color: #FF6600;
            }
          }
        }
      }
    }

    .floatTips {
      border: solid 1px #FDD096;
      position: fixed;
      bottom: 30px;
      right: 55px;
      width: 63px;
      text-align: center;
      height: 22px;
      line-height: 22px;
      background: #FAFDE8;
      color: #000;
      font-size: 12px;
    }
  }
</style>
